import { render, staticRenderFns } from "./myTitleBox.vue?vue&type=template&id=706b6eda"
import script from "./myTitleBox.vue?vue&type=script&lang=js"
export * from "./myTitleBox.vue?vue&type=script&lang=js"
import style0 from "./myTitleBox.vue?vue&type=style&index=0&id=706b6eda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports